export default __webpack_public_path__ + "static/media/1.cb241773.jpg";